import {resource} from '@albert-io/json-api-framework/request/builder';
import sessionStore from 'client/Session/SessionStore';
import {set} from 'lodash';
import {applySort} from 'components/PracticeView/PracticeViewToolbar/Sort/sort.utils';
import masqueradeStore from 'generic/Masquerade/Masquerade.store';

export function getGuideLevelQuestionSetsQuery(guideLevelId, pageSize = 20) {
  const metaContext = {
    meta: {
      context: {
        guide_level: {
          id: guideLevelId
        }
      }
    }
  };

  const userId = masqueradeStore.getUserIdByMasqueradeState();
  if (sessionStore.hasTeacherAccess()) {
    set(metaContext, 'meta.context.user.role', 'teacher');
  }

  if (userId) {
    set(metaContext, 'meta.context.user.id', userId);
  } else {
    set(metaContext, 'meta.context.no_user', true);
  }

  let query = resource('question_sets_v1')
    .mandarkEndpoint(['authoring_guide_levels_v1', guideLevelId, 'question_sets_v1'])
    .pageSize(pageSize)
    .include('authoring_subject_v1')
    .include('questions_v3')
    .include('questions_v3.question_set_v1.tags_v1')
    .include('questions_v3.standards_v1.standard_set_v1')
    .include('guide_levels_v2.guide_v1')
    .fields({
      guide_v1: 'guide_type'
    })
    .withMeta('question_v3,authoring_subject_v1,question_set_v1')
    .customQuery(metaContext, Object.keys(metaContext).length !== 0);

  query = applySort(query, 'meta.guide_level_position');
  return query;
}

export async function getGuideLevelQuestionSets(guideLevelId) {
  const questionSets = await getGuideLevelQuestionSetsQuery(guideLevelId).getResourcePromise();
  return questionSets;
}

export async function getGuideLevelDuplicateSets(guideLevelId) {
  const query = resource('authoring_guide_levels_v1')
    .mandarkEndpoint(['authoring_guide_levels_v1'])
    .filter({
      id: guideLevelId
    })
    .withMeta('authoring_guide_level_v1')
    .customQuery({
      meta: {
        context: {
          guide_level: {
            duplicate_aligned: true
          }
        }
      }
    });

  const guideLevels = await query.getResourcePromise();
  const duplicateQuestionSetIds = guideLevels.first().getMeta().getDuplicateAlignedQuestionSetIds();

  return duplicateQuestionSetIds;
}

/**
 * @param {string} subjectId
 * @param {string} guideLevelSlug
 * @returns {Promise}
 */
export function getAuthoringSubjectGuideLevelBySlug(subjectId, guideLevelSlug) {
  if (!guideLevelSlug) {
    return null;
  }
  return resource('authoring_guide_level_v1')
    .mandarkEndpoint(['authoring_guide_levels_v1'])
    .findOne()
    .filter({
      authoring_subject_v1: subjectId,
      url_slug: guideLevelSlug
    })
    .withMeta('authoring_guide_level_v1', sessionStore.hasTeacherAccess())
    .getResourcePromise();
}

/**
 * @param {string} subjectSlug
 * @param {string} userId
 * @returns {Promise}
 */
export function getAuthoringSubjectBySlug(subjectSlug, userId) {
  let query = resource('authoring_subject_v1')
    .mandarkEndpoint(['authoring_subjects_v1'])
    .findOne()
    .filter({
      url_slug: subjectSlug
    })
    .include('curriculum_area_v1');
  if (userId) {
    query = query
      .customQuery(set({}, 'meta.context.student.id', userId))
      .withMeta('authoring_subject_v1');
  }
  return query.getResourcePromise();
}
